import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import RedirectToTab from "../RedirectToCampaignTab";
import ListHospitalContractCampaigns from "./List";
import { CAMPAIGNS, CandidateServicePath, HOSPITAL_CONTRACTS } from "utils/constants";
import CreateHospitalContractCampaign from "./Create";
import EditHospitalContractCampaign from "./Edit";
import ShowHospitalContractCampaign from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  icon: <LocalHospitalIcon />,
  name: CandidateServicePath + CAMPAIGNS + `/${HOSPITAL_CONTRACTS}`,
  title: "Договор с болница",
  list: <RedirectToTab type={HOSPITAL_CONTRACTS} />,
  tabList: <ListHospitalContractCampaigns />,
  create: <CreateHospitalContractCampaign />,
  createPermission: permissions.canCreateCampaigns,
  edit: <EditHospitalContractCampaign />,
  editPermission: permissions.canUpdateCampaigns,
  show: <ShowHospitalContractCampaign />,
  showPermission: permissions.canPreviewCampaigns,
  permission: permissions.canPreviewCampaigns,
};
